const TOKEN_KEY = "teddygram:token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setToken = (t: string) => localStorage.setItem(TOKEN_KEY, t);

export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaderFor = (token: string): HeadersInit => ({
  Authorization: `Basic ${btoa(`${token}:`)}`,
});

export const authHeader = (): HeadersInit => {
  const token = getToken();
  return token ? authHeaderFor(token) : {};
};
